import * as React from 'react';
import { IconButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const RemoveVoucherCode = ({ voucherCode , onRemove , 'data-t': dataT  })=>{
    return /*#__PURE__*/ React.createElement(IconButton, {
        key: voucherCode,
        className: "cart__applied-discount-button",
        onClick: onRemove,
        "data-t": dataT
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "cart__applied-discount-icon",
        name: "close",
        width: 18,
        height: 18
    }));
};

export { RemoveVoucherCode };
//# sourceMappingURL=RemoveVoucherCode.js.map
